import { getAxiosClient } from "../../axios-client";
import {
  StorageAreaDeleteRequestBody,
  StorageAreaDeleteResponse,
} from "./types";

const axiosClient = getAxiosClient();
export const deleteStorageArea = async (body: StorageAreaDeleteRequestBody) => {
  return await axiosClient.ax.delete<StorageAreaDeleteResponse>(
    "/StorageArea/Delete",
    { data: body }
  );
};
